import classNames from 'classnames';
import React, { useCallback } from 'react';
import {
  Globe,
  Mail,
  MapPin,
  Navigation,
  Phone,
  DollarSign,
} from 'react-feather';

import { CITY_LIST } from '../data/cityList';
import { Clinic } from '../models/clinic';
import { Card } from './Card';
import styles from './ClinicCard.module.css';
import { formatPhone } from '../utils';

interface Props {
  clinic: Clinic;
  isActive: boolean;

  onSelect(clinicId: number): void;
}

export const ClinicCard: React.FC<Props> = ({ clinic, isActive, onSelect }) => {
  const {
    id,
    coords,
    city: cityId,
    email,
    price,
    phones,
    title,
    website,
  } = clinic;

  const city = CITY_LIST.find(item => item.id === cityId);
  const navigate = useCallback(() => {
    (window as any).map.flyTo(coords, 17);
    (window as any)[`popup_${clinic.id}`].openOn((window as any).map);
    onSelect(id);
  }, []);

  return (
    <Card className={classNames(styles.container, isActive && styles.active)}>
      <header className={styles.header} onClick={navigate}>
        <h3 className={styles.title}>{title}</h3>
        <button
          className={styles.navigation}
          onClick={navigate}
          title='Show on the map'>
          <Navigation size={16} />
        </button>
      </header>
      <div className={styles.body}>
        {city && (
          <span className={styles.row}>
            <MapPin className={styles.icon} />
            {city.title}
          </span>
        )}
        {phones.length > 0 && (
          <span className={styles.row}>
            <Phone className={styles.icon} />
            {phones.map(formatPhone).join(', ')}
          </span>
        )}
        {price && (
          <span className={styles.row}>
            <DollarSign className={styles.icon} />
            {Intl.NumberFormat('en', {
              currency: 'eur',
              currencyDisplay: 'name',
              minimumFractionDigits: 0,
              style: 'currency',
            }).format(price)}
          </span>
        )}
        {email && (
          <span className={styles.row}>
            <Mail className={styles.icon} />
            <a className={styles.link} href={`mailto:${email}`}>
              {email}
            </a>
          </span>
        )}
        {website && (
          <span className={styles.row}>
            <Globe className={styles.icon} />
            <a className={styles.link} target='_blank' href={`//${website}`}>
              {website}
            </a>
          </span>
        )}
      </div>
    </Card>
  );
};
